'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var navData = {
  primaryNavData: [{
    name: 'MISSION',
    link: 'https://www.lanl.gov/mission/index.php',
    menuItems: []
  }, {
    name: 'SCIENCE & INNOVATION',
    link: null,
    menuItems: [{
      groupName: 'SCIENCE & INNOVATION',
      link: 'https://www.lanl.gov/science-innovation/index.php',
      groupItems: [{
        name: 'Science Highlights',
        link: 'https://www.lanl.gov/science-innovation/index.php'
      }, {
        name: 'Science Briefs',
        link: 'https://www.lanl.gov/discover/science-briefs/index.php'
      }, {
        name: 'Science Facilities',
        link: 'https://www.lanl.gov/science-innovation/science-facilities/index.php'
      }, {
        name: 'Capability Pillars',
        link: 'https://www.lanl.gov/science-innovation/pillars/index.php'
      }, {
        name: 'Science Videos',
        link: 'https://www.lanl.gov/science-innovation/science-videos1.php'
      }, {
        name: 'Lab Organizations',
        link: 'https://www.lanl.gov/org/index.php'
      }, {
        name: 'Research Library',
        link: 'http://www.lanl.gov/library/index.php'
      }]
    }, {
      groupName: 'SCIENCE PROGRAMS',
      link: 'https://www.lanl.gov/science-innovation/science-programs/index.php',
      groupItems: [{
        name: 'Applied Energy Programs',
        link: 'https://www.lanl.gov/science-innovation/science-programs/applied-energy-programs/index.php'
      }, {
        name: 'Civilian Nuclear Energy Programs',
        link: 'https://www.lanl.gov/science-innovation/science-programs/civilian-nuclear-programs/index.php'
      }, {
        name: 'Laboratory Directed Research & Development (LDRD)',
        link: 'https://www.lanl.gov/science-innovation/science-programs/ldrd/index.php'
      }, {
        name: 'National Security Education Center (NSEC)',
        link: 'https://www.lanl.gov/projects//national-security-education-center/index.php'
      }, {
        name: 'Office of Science Programs',
        link: 'https://www.lanl.gov/science-innovation/science-programs/office-of-science-programs/index.php'
      }]
    }]
  }, {
    name: 'COLLABORATION',
    link: null,
    menuItems: [{
      groupName: 'USER FACILITIES',
      link: 'https://www.lanl.gov/collaboration/user-facilities/index.php',
      groupItems: [{
        name: 'CINT',
        link: 'http://cint.lanl.gov/index.php'
      }, {
        name: 'LANSCE',
        link: 'http://lansce.lanl.gov/'
      }, {
        name: 'NHMFL',
        link: 'https://nationalmaglab.org/user-facilities/pulsed-field-facility'
      }, {
        name: 'Biosurveillance Gateway',
        link: 'https://www.lanl.gov/projects//biosurveillance-gateway/index.php'
      }, {
        name: 'Pathogen Databases',
        link: 'https://www.lanl.gov/collaboration/pathogen-database/index.php'
      }]
    }, {
      groupName: 'FEYNMAN CENTER FOR INNOVATION',
      link: 'https://www.lanl.gov/projects//feynman-center/index.shtml',
      groupItems: [{
        name: 'LACED',
        link: 'https://www.lanl.gov/projects//explosives-detection/index.php'
      }, {
        name: 'Exascale Computing Project',
        link: 'https://www.lanl.gov/projects//exascale-computing-project/index.php'
      }, {
        name: 'FUTURE',
        link: 'https://www.lanl.gov/projects//future/index.php'
      }]
    }, {
      groupName: 'NATIONAL SECURITY EDUCATION CENTER (NSEC)',
      link: 'https://www.lanl.gov/projects//national-security-education-center/index.php',
      groupItems: [{
        name: 'Center for Nonlinear Studies',
        link: 'https://www.lanl.gov/projects//national-security-education-center/center-nonlinear-studies/index.php'
      }, {
        name: 'Engineering Institute',
        link: 'https://www.lanl.gov/projects//national-security-education-center/engineering/index.php'
      }, {
        name: 'Information Science & Technology Institute',
        link: 'https://www.lanl.gov/projects//national-security-education-center/information-science-technology/index.php'
      }, {
        name: 'Center for Space and Earth Science',
        link: 'https://www.lanl.gov/projects//national-security-education-center/space-earth-center/index.php'
      }, {
        name: 'Institute for Materials Science',
        link: 'https://www.lanl.gov/projects//national-security-education-center/institute-for-materials-science/index.php'
      }, {
        name: 'Seaborg Institute',
        link: 'https://www.lanl.gov/projects//national-security-education-center/seaborg/index.php'
      }, {
        name: 'Fellows',
        link: 'https://www.lanl.gov/collaboration/fellows/index.php'
      }]
    }, {
      groupName: 'RESEARCH OPPORTUNITIES',
      link: 'https://www.lanl.gov/collaboration/research-opportunities/index.php',
      groupItems: [{
        name: 'Service Academies and ROTC Research Associates',
        link: 'https://www.lanl.gov/collaboration/internships/service-academy-research-associates/index.php'
      }, {
        name: 'Strategic Analyses and Assessments Office',
        link: 'https://www.lanl.gov/projects/strategic-analyses-and-assessments/index.php'
      }]
    }]
  }, {
    name: 'COMMUNITY',
    link: null,
    menuItems: [{
      groupName: 'COMMUNITY COMMITMENT',
      link: 'https://www.lanl.gov/community/index.php',
      groupItems: [{
        name: 'Giving campaigns, drives',
        link: 'https://www.lanl.gov/community/giving/index.php'
      }, {
        name: 'Economic development',
        link: 'https://www.lanl.gov/community/economic-development.php'
      }, {
        name: 'Grants and Sponsorships',
        link: 'https://www.lanl.gov/community/grantapplication.php'
      }]
    }, {
      groupName: 'STEM EDUCATION',
      link: 'https://www.lanl.gov/community/education/index.php',
      groupItems: [{
        name: 'Teachers (K-12)',
        link: 'https://www.lanl.gov/community/education/stem-education-programs.php'
      }, {
        name: 'Students (K-12)',
        link: 'https://www.lanl.gov/community/education/teacher-resources/index.php'
      }, {
        name: 'Higher education',
        link: 'https://www.lanl.gov/community/education/higher-education-resources/index.php'
      }, {
        name: 'Regional education partners',
        link: 'https://www.lanl.gov/community/education/regional-partners/index.php'
      }, {
        name: "NM Governor's STEM Challenge",
        link: 'https://www.lanl.gov/community/education/stem-challenge/index.php'
      }]
    }, {
      groupName: 'INTERNAL',
      link: 'https://www.lanl.gov/community/visitors/index.php',
      groupItems: [{
        name: 'Badging, Badge Office',
        link: 'https://www.lanl.gov/community/visitors/badging/index.php'
      }, {
        name: 'Bradbury Science Museum',
        link: 'https://www.lanl.gov/community/visitors/bradbury-science-museum.php'
      }, {
        name: 'Housing',
        link: 'https://www.lanl.gov/community/visitors/housing.php'
      }, {
        name: 'Maps',
        link: 'https://www.lanl.gov/resources/maps.php'
      }]
    }, {
      groupName: 'RELATED RESOURCES',
      link: '',
      groupItems: [{
        name: 'Calendar',
        link: 'http://www.lanl.gov/calendar/'
      }, {
        name: 'Community Connections',
        link: 'https://discover.lanl.gov/publications/connections'
      }, {
        name: 'Community feature stories',
        link: 'https://www.lanl.gov/community/stories/index.php'
      }]
    }]
  }, {
    name: 'ENVIRONMENT',
    link: null,
    menuItems: [{
      groupName: 'ENVIRONMENTAL PROTECTION',
      link: 'https://www.lanl.gov/environment/protection/index.php',
      groupItems: [{
        name: 'What we monitor and why',
        link: 'https://www.lanl.gov/environment/protection/monitoring/index.php'
      }, {
        name: 'Cultural preservation',
        link: 'https://www.lanl.gov/environment/protection/cultural-preservation/index.php'
      }, {
        name: 'Taking care of our trails',
        link: 'https://www.lanl.gov/environment/protection/trails/index.php'
      }, {
        name: 'Obeying environmental laws',
        link: 'https://www.lanl.gov/environment/protection/compliance/index.php'
      }, {
        name: 'Protecting Wildlife',
        link: 'https://www.lanl.gov/environment/protection/wildlife-protection/index.php'
      }]
    }, {
      groupName: 'ENVIRONMENTAL SUSTAINABILITY',
      link: 'https://www.lanl.gov/environment/sustainability/index.php',
      groupItems: [{
        name: 'Sustainability goals',
        link: 'https://www.lanl.gov/environment/sustainability/goals/index.php'
      }, {
        name: 'Recycling',
        link: 'https://www.lanl.gov/environment/sustainability/recycling.php'
      }, {
        name: 'Green purchasing',
        link: 'https://www.lanl.gov/environment/sustainability/green-purchasing.php'
      }, {
        name: 'Pollution prevention',
        link: 'https://www.lanl.gov/environment/sustainability/pollution-prevention.php'
      }, {
        name: 'Reusing water',
        link: 'https://www.lanl.gov/environment/sustainability/water-reuse.php'
      }]
    }, {
      groupName: 'RESOURCES',
      link: '',
      groupItems: [{
        name: 'Environmental Management System',
        link: 'https://www.lanl.gov/environment/protection/environmental-management-system.php'
      }, {
        name: 'Feature stories',
        link: 'https://www.lanl.gov/environment/stories/index.php'
      }, {
        name: 'Public Reading Room',
        link: 'https://www.lanl.gov/environment/public-reading-room.php'
      }]
    }, {
      groupName: 'ENVIRONMENT HOME',
      link: 'https://www.lanl.gov/environment/index.php',
      groupItems: []
    }]
  }],
  quickLinksNavData: [{
    name: 'Quick Links',
    items: [{
      name: 'About',
      link: 'https://www.lanl.gov/about/index.php'
    }, {
      name: 'Badging',
      link: 'https://www.lanl.gov/community/visitors/badging/index.php'
    }, {
      name: 'Business',
      link: 'https://www.lanl.gov/business/procurement-opportunities.php'
    }, {
      name: 'Contacts',
      link: 'https://www.lanl.gov/resources/contacts.php'
    }, {
      name: 'Maps',
      link: 'https://www.lanl.gov/resources/maps.php'
    }, {
      name: 'Mission',
      link: 'https://www.lanl.gov/mission/index.php'
    }, {
      name: 'Museum',
      link: 'https://www.lanl.gov/museum//index.php'
    }, {
      name: 'Organizations',
      link: 'https://www.lanl.gov/org/index.php'
    }, {
      name: 'New Hires',
      link: 'https://www.lanl.gov/careers/employees-retirees/new-hires/index.php'
    }, {
      name: 'Publications',
      link: 'https://discover.lanl.gov/publications/'
    }, {
      name: 'Research Library',
      link: 'http://www.lanl.gov/library//index.php'
    }]
  }]
};
exports['default'] = navData;